import React, { useEffect } from "react";
import "../styles/components/footer-news.css"; // Import your CSS file
import * as styles2 from "../styles/components/newsletter.module.css";
import { cn } from "../lib/helpers";
import { Link } from "gatsby";

const FooterNewsLetter = () => {
  useEffect(() => {
    // Load the Marketo form
    let mktforms2 = window.MktoForms2;
    if (mktforms2) {
      mktforms2.loadForm("https://lp.pureweb.com", "913-VOO-268", 1032);

      mktforms2.whenReady(function (form) {
        // Add an onSuccess handler
        form.onSuccess(function (values, followUpUrl) {
          // Get the form's jQuery element and hide it
          form.getFormElem().hide();
          document.getElementById("confirmform").style.visibility = "visible";
          document.getElementById("confirmform").style.display = "block";
          return false;
        });
        form.offSuccess(function (values, followUpUrl) {
          // Get the form's jQuery element and hide it
          console.log("here")
        });
        
      });
    }
  }, []); // Empty dependency array ensures useEffect runs only once

  return (
    <>
      {/* Insert the Marketo Form */}
      <div id="form-control-marketo">
      <h5 className={cn("color-palette-color", styles2.newsletterTitle)}>
      Get on the List
      </h5>
      <p>
      Sign up for our mailling list to be the first to learn about new product features, news and updates, helpful resources, and more.
      </p>
      <form className={"mktoForm_1032"} id="mktoForm_1032"></form>
      <div id="confirmform" style={{ visibility: "hidden",display:"none" }}>
        <p>Thank you for signing up for our newsletter.</p>
      </div>
      <div id="message" className={styles2.message}>
        To view our privacy policy,{" "}
        <Link className={"color-palette-color"} href={`/privacy-policy`}>
          click here.
        </Link>
      </div>
      </div>

      {/* Confirmation message for the Marketo form */}
    </>
  );
};

export default FooterNewsLetter;
